export default "__VITE_ASSET__C4jTb8he__"